import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Head from "next/head";
import { defaultMetatags } from "@/lib/constants";
import { useAdultModeQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function adultOrVod(adultMode) {
  return adultMode ? "adult" : "vod";
}

function createValue(value, key, adultMode) {
  if (value) {
    return value;
  } else {
    var defaultValue = key.split(".").reduce(function (acc, v) {
      return acc === null || acc === void 0 ? void 0 : acc[v];
    }, defaultMetatags === null || defaultMetatags === void 0 ? void 0 : defaultMetatags[adultOrVod(adultMode)]);
    return defaultValue;
  }
}

export function MetaTag(_ref) {
  var title = _ref.title,
      keywords = _ref.keywords,
      description = _ref.description;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      loading = _useAdultModeQuery.loading,
      data = _useAdultModeQuery.data;

  var adultMode = data === null || data === void 0 ? void 0 : data.adultMode;
  if (loading) return null;
  var titleValue = createValue(title, "title", adultMode);
  var keywordsContent = createValue(keywords, "keywords", adultMode);
  var descriptionContent = createValue(description, "description", adultMode);
  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("title", {
      children: titleValue
    }, "title"), /*#__PURE__*/_jsx("meta", {
      name: "keywords",
      content: keywordsContent
    }, "keywords"), /*#__PURE__*/_jsx("meta", {
      name: "description",
      content: descriptionContent
    }, "description")]
  });
}
export function Og(_ref2) {
  var type = _ref2.type,
      title = _ref2.title,
      description = _ref2.description,
      url = _ref2.url,
      image = _ref2.image;

  var _useAdultModeQuery2 = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      loading = _useAdultModeQuery2.loading,
      data = _useAdultModeQuery2.data;

  var adultMode = data === null || data === void 0 ? void 0 : data.adultMode;
  if (loading) return null;
  var titleContent = createValue(title, "og.title", adultMode);

  var ogurl = function () {
    if (true) {
      return window.location.href;
    } else {
      return url || defaultMetatags[adultOrVod(adultMode)].og.url;
    }
  }();

  var descriptionContent = createValue(description, "og.description", adultMode);
  var imageContent = createValue(image, "og.image", adultMode);
  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("meta", {
      property: "og:title",
      content: titleContent
    }, "ogtitle"), /*#__PURE__*/_jsx("meta", {
      property: "og:url",
      content: ogurl
    }, "ogurl"), /*#__PURE__*/_jsx("meta", {
      property: "og:type",
      content: type
    }, "ogtype"), /*#__PURE__*/_jsx("meta", {
      property: "og:description",
      content: descriptionContent
    }, "ogdescription"), /*#__PURE__*/_jsx("meta", {
      property: "og:image",
      content: imageContent
    }, "ogimage")]
  });
}
export function TwitterCard(_ref3) {
  var title = _ref3.title,
      description = _ref3.description,
      card = _ref3.card,
      image = _ref3.image;

  var _useAdultModeQuery3 = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      loading = _useAdultModeQuery3.loading,
      data = _useAdultModeQuery3.data;

  var adultMode = data === null || data === void 0 ? void 0 : data.adultMode;
  if (loading) return null;
  var titleContent = createValue(title, "twitter.title", adultMode);
  var descriptionContent = createValue(description, "twitter.description", adultMode);
  var imageContent = createValue(image, "twitter.image", adultMode);
  return /*#__PURE__*/_jsxs(Head, {
    children: [/*#__PURE__*/_jsx("meta", {
      name: "twitter:title",
      content: titleContent
    }, "twittertitle"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:description",
      content: descriptionContent
    }, "twitterdescription"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:card",
      content: card
    }, "twittercard"), /*#__PURE__*/_jsx("meta", {
      name: "twitter:image",
      content: imageContent
    }, "twitterimage")]
  });
}
export function Robots(_ref4) {
  var content = _ref4.content;
  if (!content) return null;
  return /*#__PURE__*/_jsx(Head, {
    children: /*#__PURE__*/_jsx("meta", {
      name: "robots",
      content: content
    }, "robots")
  });
}
export function CanonicalUrl(_ref5) {
  var href = _ref5.href;
  if (!href) return null;
  return /*#__PURE__*/_jsx(Head, {
    children: /*#__PURE__*/_jsx("link", {
      rel: "canonical",
      href: href
    })
  });
}
export default function MetaTags(_ref6) {
  var title = _ref6.title,
      keywords = _ref6.keywords,
      description = _ref6.description,
      og = _ref6.og,
      twitter = _ref6.twitter,
      robots = _ref6.robots,
      canonicalUrl = _ref6.canonicalUrl;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MetaTag, {
      title: title,
      keywords: keywords,
      description: description
    }), /*#__PURE__*/_jsx(Og, _objectSpread({}, _objectSpread({
      description: description
    }, og))), /*#__PURE__*/_jsx(TwitterCard, _objectSpread({}, _objectSpread(_objectSpread({}, twitter), {}, {
      description: description
    }))), /*#__PURE__*/_jsx(Robots, {
      content: robots
    }), /*#__PURE__*/_jsx(CanonicalUrl, {
      href: canonicalUrl
    })]
  });
}